import { apiClient } from './apiClient';

// Types
export interface Plan {
  id: string;
  slug: string;
  name: string;
  description: string | null;
  dailyTokenLimit: number | null;
  weeklyTokenLimit: number | null;
  monthlyTokenLimit: number | null;
  features: Record<string, unknown>;
  isActive: boolean;
  isDefault: boolean;
  requiresExternalValidation: boolean;
  displayOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface UpdatePlanInput {
  name?: string;
  description?: string;
  dailyTokenLimit?: number | null;
  weeklyTokenLimit?: number | null;
  monthlyTokenLimit?: number | null;
  features?: Record<string, unknown>;
  isActive?: boolean;
  displayOrder?: number;
}

export interface AssignPlanInput {
  planId: string;
}

// Plans Service
class PlansService {
  /**
   * Listar todos os planos
   */
  async listPlans(): Promise<Plan[]> {
    const response = await apiClient.get<{ plans: Plan[] }>('/auth/plans');
    return response.data.plans;
  }

  /**
   * Obter plano por ID
   */
  async getPlanById(id: string): Promise<Plan> {
    const response = await apiClient.get<{ plan: Plan }>(`/auth/plans/${id}`);
    return response.data.plan;
  }

  /**
   * Atualizar plano
   */
  async updatePlan(id: string, data: UpdatePlanInput): Promise<Plan> {
    const response = await apiClient.put<{ plan: Plan }>(`/auth/plans/${id}`, data);
    return response.data.plan;
  }

  /**
   * Atribuir plano a um usuário
   */
  async assignPlanToUser(userId: string, planId: string): Promise<void> {
    await apiClient.put(`/auth/plans/user/${userId}`, { planId });
  }

  /**
   * Buscar plano de um usuário
   */
  async getUserPlan(userId: string): Promise<{ userId: string; plan: Plan | null }> {
    const response = await apiClient.get<{ userId: string; plan: Plan | null }>(`/auth/plans/user/${userId}`);
    return response.data;
  }
}

export default new PlansService();
